<template>
	<div class="Search">
		<div class="videoBox" v-if="videoInfo && videoInfo.poster && videoInfo.videoUrl">
			<div class="videoPlayer">
				<video-player class="video-player vjs-custom-skin" ref="videoPlayer" playsinline
					:options="playerOptions">
				</video-player>
				<!-- <vue-plyr ref="player" :options="options">
					<video controls crossorigin playsinline :poster="videoInfo.poster">
						<source :src="videoInfo.videoUrl" type="video/mp4" />
					</video>
				</vue-plyr> -->
			</div>
			<div class="titleTime">
				<div class="timeBox">
					发布于{{detailsData.UpdateDate}}
				</div>
				<div class="playNum">
					{{detailsData.Clicks}}次播放
				</div>
			</div>
			<div class="videoTitle">
				{{detailsData.Title}}
			</div>
			<div class="desBox">
				{{detailsData.Intro}}
			</div>
		</div>
		<div class="videoListBox" v-if="videoInfo && videoInfo.poster && videoInfo.videoUrl">
			<div class="contentStyle">
				<div class="styleHeader">
					<div class="headerBox">
						<span class="lineBox"></span>
						<span class="headerTitle">更多推荐</span>
					</div>
				</div>
				<div class="videoListSBox" v-if="detailsData && detailsData.Recommand">
					<div class="itemSBox" v-for="(item,index) in detailsData.Recommand" :key="index">
						<div class="imgSBox" @click="naviToHotDetails(item)">
							<img :src="item.CoverUrlPortrait" alt="">
							<div class="timeNumBox">
								{{item.Duration}}
								<div class="numBox">
									{{item.Clicks}}次播放
								</div>
							</div>
						</div>
						<div class="infoSBox">
							<div class="videoTitle" @click="naviToHotDetails(item)">
								{{item.Title}}
							</div>
							<div class="videoSubTitle">
								{{item.Intro}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="loading" v-if="isLoading">
			<img src="https://img.alicdn.com/tfs/TB1qa_fdQL0gK0jSZFtXXXQCXXa-88-88.gif" alt="">
		</div>
	</div>
</template>

<script>
	import VuePlyr from 'vue-plyr'
	import 'vue-plyr/dist/vue-plyr.css'
	var wx = require('jweixin-module')
	export default {
		name: 'phoneDetails',
		components: {
			VuePlyr
		},
		data() {
			return {
				videoInfo: {
					poster: '',
					videoUrl: '',
				},
				isLoading: false,
				detailsData: {},
				playerOptions: {
					playbackRates: [1.0, 1.5, 2.0], //播放速度
					autoplay: false, // 如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					// aspectRatio: '15:6', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [],
					poster: "", // 封面地址
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 时间分割线
						durationDisplay: true, // 总时间
						remainingTimeDisplay: true, // 剩余播放时间
						progressControl: true, // 进度条 
						fullscreenToggle: true // 全屏按钮
					}
				},
				options: {
					controls: ['play-large', 'play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'captions',
						'settings', 'pip', 'airplay', 'fullscreen'
					],
					i18n: {
						speed: '速度',
						normal: '正常',
						play: '播放',
						pause: '暂停',
						pip: '画中画',
						enterFullscreen: '进入全屏',
						exitFullscreen: '退出全屏',
						mute: '音量',
						unmute: '解除静音',
						settings: '设置',
					},
					tooltips: {
						controls: true,
						seek: true,
					},
					loop: {
						active: true,
					},
				},
			}
		},
		mounted() {
			this.getVlogVideoDetail()
		},
		methods: {
			naviToHotDetails(item) {
				this.$router.push({
					path: '/pDetails',
					query: {
						videoId: item.VId
					}
				});
				window.location.reload()
			},
			//视频详情
			getVlogVideoDetail() {
				this.isLoading = true
				this.$api.post('/VideoNew/getVlogVideoDetail', {
					VId: this.$route.query.videoId
				}).then(res => {
					if (res.code == 200) {
						this.shareWechat()
						this.detailsData = res.data
						this.getVideoPlayInfo(this.detailsData.VideoId)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			getVideoPlayInfo(videoId) {
				this.$api.post('/VideoNew/getVideoPlayInfo', {
					videoId: videoId
				}).then(res => {
					if (res.code == 200) {
						this.playerOptions.poster = res.data[0].PlayAuth.VideoMeta.CoverURL
						// this.playerOptions.sources[0].url = res.data[0].PlayURL
						let video = {
							src: res.data[0].PlayURL, // 路径
							type: 'video/mp4' // 类型
						};
						this.playerOptions.sources.push(video);
						this.videoInfo.poster = res.data[0].PlayAuth.VideoMeta.CoverURL
						this.videoInfo.videoUrl = res.data[0].PlayURL
					}
					this.isLoading = false
				}).catch(err => {
					console.log(err);
				})
			},
			shareWechat() {
				let _this = this;
				let getId = this.$route.query.videoId;
				let url = `https://cfni.cn/#/pDetails?videoId=${getId}`;
				this.$api.get('/share/wxshare', {
					url: url,
					_: '1698686698468',
				}).then(res => {
					if (res.code == 200) {
						wx.config({
							debug: false,
							appId: res.data.appId, // 必填，公众号的唯一标识
							timestamp: res.data.timestamp, // 必填，生成签名的时间戳<?= $data['timestamp']?>
							nonceStr: res.data.nonceStr, // 必填，生成签名的随机串<?= $data['noncestr']?>
							signature: res.data.signature, // 必填，签名<?= $data['signature']?>
							jsApiList: [
								'onMenuShareTimeline',
								'onMenuShareAppMessage'
							]
						});
						wx.ready(function() {
							let shareData = { //朋友圈
								title: _this.detailsData.Title, // 分享标题
								desc: _this.detailsData.Intro, // 分享描述
								// link: 'http://web.bandaolv.com/#/pDetails?videoId=' + _this.detailsData.VId,
								link: url,
								imgUrl: 'https://cfni.cn/shareLogo.png'
							};
							// 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
							wx.onMenuShareAppMessage(shareData);
							// 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
							wx.onMenuShareTimeline(shareData);
						});
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.loading {
		position: absolute;
		left: calc(50% - 22px);
		top: 70px;

		img {
			width: 44px;
			height: 44px;
		}
	}

	.videoBox {
		width: 100%;

		.videoPlayer {
			width: 100%;
			height: calc(100vw / 1.78);
		}

		.titleTime {
			display: flex;
			justify-content: space-between;

			.timeBox {
				display: flex;
				align-items: center;
				margin-top: 12px;
				margin-left: 12px;
				font-size: 12px;
				font-weight: 400;
				color: #999999;
			}

			.playNum {
				margin-top: 12px;
				margin-right: 12px;
				text-align: right;
				font-size: 12px;
				font-weight: 400;
				color: #999999;
			}
		}

		.videoTitle {
			margin: 12px 12px 0px;
			font-size: 17px;
			font-weight: 500;
			color: #FAF7F7;
		}

		.desBox {
			margin: 8px 12px 0px;
			font-size: 14px;
			font-weight: 400;
			color: #999999;
		}
	}

	.videoListBox {
		margin-top: 38px;
		margin-left: 12px;
	}

	.contentStyle {
		color: rgba(255, 255, 255, 0.87);

		.styleHeader {
			display: flex;
			margin-bottom: 8px;

			.headerBox {
				display: flex;
				align-items: center;

				.lineBox {
					width: 4px;
					height: 14px;
					background: #DB4641;
					margin-right: 8px;
				}

				.headerTitle {
					font-size: 14px;
					font-weight: 600;
					color: #FAF7F7;
				}
			}
		}

		.videoListSBox {
			display: flex;
			flex-wrap: wrap;
			padding-bottom: 40px;

			.itemSBox {
				margin-top: 14px;
				padding-right: 12px;
				box-sizing: border-box;
				width: calc((100vw - 12px) / 2);

				.imgSBox {
					height: calc((100vw - 36px) / 2 * 1.7778);
					border-radius: 10px 10px 0px 0px;
					background: #25252b;
					position: relative;
					overflow: hidden;
					cursor: pointer;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.timeNumBox {
						display: flex;
						align-items: center;
						justify-content: space-between;
						width: 100%;
						height: 26px;
						line-height: 26px;
						background: rgba(4, 4, 4, .29);
						position: absolute;
						bottom: 0px;
						left: 0px;
						text-align: right;
						padding: 0px 12px;
						box-sizing: border-box;
						font-size: 12px;
						font-weight: 400;
						color: #FAF7F7;
					}
				}

				.infoSBox {
					padding-top: 10px;

					.videoTitle {
						height: 22px;
						width: 100%;
						line-height: 22px;
						font-size: 16px;
						font-weight: 500;
						overflow: hidden;
						text-overflow: ellipsis;
						word-break: break-all;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						word-break: break-word;
						cursor: pointer;
					}

					.videoTitle:hover {
						color: #4ae3fa;
					}

					.videoSubTitle {
						color: rgba(255, 255, 255, 0.5);
						margin-top: 3px;
						height: 14px;
						line-height: 14px;
						font-size: 14px;
						font-weight: 400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}
</style>